<ng-container *ngIf="tooltipText">
  <ui-svg-icon
    [name]="iconType"
    [width]="iconSizesMap[iconSize]"
    class="{{ iconColorsMap[iconColor] }} tw-cursor-pointer"
    [matTooltip]="tooltipText"
    [matTooltipPosition]="tooltipPosition"
  ></ui-svg-icon>
</ng-container>
